import { API_BASE_URL } from '../config';

// JSON request to the backend. Resolves with the parsed body, or throws an Error
// carrying the server's message so screens can show it.
export async function api(path, { method = 'GET', body } = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }
  if (!response.ok) {
    throw new Error((data && (data.error || data.message)) || `Request failed (${response.status}).`);
  }
  return data;
}
